/** Web stub — treat browser as non-emulator for UI dev. */
export default {
  isEmulator: async () => false,
};
